export default __webpack_public_path__ + "static/media/magical-1.f633b578.jpg";